export default "__VITE_ASSET__C8J2ypp2__"